module.exports = __webpack_public_path__ + "static/media/add1.0e92cfd2.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/add1.svg
// module id = 6215
// module chunks = 0